import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import './App.css';

// Importar páginas
import LoginPage from './features/auth/LoginPage';
import RegisterPage from './features/auth/RegisterPage';
import VerifyEmailPage from './features/auth/VerifyEmailPage';
import ForgotPasswordPage from './features/auth/ForgotPasswordPage';
import ResetPasswordPage from './features/auth/ResetPasswordPage';
import GroupsPage from './features/groups/GroupsPage';
import CreateGroupPage from './features/groups/CreateGroupPage';
import GroupDetailPage from './features/groups/GroupDetailPage';
import JoinGroupPage from './features/groups/JoinGroupPage';
import AddExpensePage from './features/expenses/AddExpensePage';
import BalancePage from './features/balance/BalancePage';
import InvitesPage from './features/invites/InvitesPage';
import PaymentPage from './features/payments/PaymentPage';
import PaymentSharePage from './features/payments/PaymentSharePage';
import PendingConfirmationPage from './features/payments/PendingConfirmationPage';
import PixKeyPage from './features/profile/PixKeyPage';
import ProfilePage from './features/profile/ProfilePage';

// Importar componentes
import NavbarComponent from './components/Navbar';
import PrivateRoute from './components/PrivateRoute';

/**
 * Componente principal da aplicação.
 * Configura rotas e estrutura básica do app.
 */
function App() {
  return (
    <Router>
      <div className="App">
        <NavbarComponent />
        <Routes>
          {/* Rotas públicas */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/payment/:paymentId" element={<PaymentSharePage />} />
          <Route path="/invite/:token" element={<JoinGroupPage />} />

          {/* Rotas protegidas */}
          <Route
            path="/groups"
            element={
              <PrivateRoute>
                <GroupsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/groups/new"
            element={
              <PrivateRoute>
                <CreateGroupPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/groups/:id"
            element={
              <PrivateRoute>
                <GroupDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/groups/:groupId/expenses/new"
            element={
              <PrivateRoute>
                <AddExpensePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/groups/:groupId/balance"
            element={
              <PrivateRoute>
                <BalancePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/invites"
            element={
              <PrivateRoute>
                <InvitesPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/payments/:paymentId"
            element={
              <PrivateRoute>
                <PaymentPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/payments/pending-confirmation"
            element={
              <PrivateRoute>
                <PendingConfirmationPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/settings/pix"
            element={
              <PrivateRoute>
                <PixKeyPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <ProfilePage />
              </PrivateRoute>
            }
          />

          {/* Rota padrão */}
          <Route path="/" element={<Navigate to="/groups" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
